'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inHouseAnalyticsConnectorFactory = undefined;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _clientSide = require('../utils/clientSide');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var renderToStringScript = function renderToStringScript(body) {
  return 'window.__inhouseSend__(' + JSON.stringify(body) + ');';
};

var inHouseAnalyticsConnectorFactory = exports.inHouseAnalyticsConnectorFactory = function inHouseAnalyticsConnectorFactory(options) {
  var holdedEvents = [];

  var send = function send(payload) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        sendInHouseAnalytics = _ref.sendInHouseAnalytics;

    var isInHouseAnalyticsEnabled = sendInHouseAnalytics || options.sendInHouseAnalytics;

    if (!isInHouseAnalyticsEnabled || !payload.eventName) {
      return;
    }

    var body = {
      query: '\n          mutation pushInhouseEvent($input:Event!) {\n            pushEvent(input:$input)\n          }\n        ',
      variables: {
        input: {
          eventName: payload.eventName
        }
      }
    };

    if ((0, _clientSide.isClientSide)()) {
      _axios2.default.post('/marketplace/graphql', body);
    } else {
      holdedEvents.push(body);
    }
  };

  var flush = function flush() {
    var flushedEvents = holdedEvents.map(renderToStringScript);
    holdedEvents = [];

    return flushedEvents.length ? [_constants.INITIALIZE_INHOUSE_ANALYTICS].concat(_toConsumableArray(flushedEvents)).join('') : '';
  };

  return {
    send: send,
    setCustomDimension: function setCustomDimension() {},
    flush: flush
  };
};

exports.default = {
  inHouseAnalyticsConnectorFactory: inHouseAnalyticsConnectorFactory
};
//# sourceMappingURL=inhouse_analytics.js.map